const modal = $("#subscriptionModal");

export function subscriptionModal() {
    modal.modal("show");
}
